import Vue from "vue";
import Vuex from "vuex";
import localStorage from "store2";
import { setuserInfo } from "@/utills/constant.js";
import { apiQueryUserPermission } from "@/api/userApi";
import { cloneDeep } from 'lodash';
import {getSeletedRoutes ,filterDynamicRoutes} from "./permisson";
import router ,{ DynamicRoutes } from "../router";

Vue.use(Vuex);

const state = {
  token: localStorage.get(setuserInfo.SET_USER_TOKEN),
  userInfo: localStorage.get(setuserInfo.USER_INFO),
  agnetList: [],
  permissionRoutesList: [],  //后端返回的路由权限列表
  dynamicRoutesList:[], //需要动态添加的路由列表
  permissionButtons:[] //按钮权限列表
};
const mutations = {
  LOGIN_IN(state, token) {
    state.token = token;
    localStorage.set(setuserInfo.SET_USER_TOKEN, token);
  },

  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
    localStorage.set(setuserInfo.USER_INFO, userInfo);
  },

  SET_AGENT_LIST(state, agnetList) {
    state.agnetList = agnetList;
  },

  SET_PERMISSION_ROUTES_LIST(state, permissionRoutesList) {
    state.permissionRoutesList = permissionRoutesList;
  },

  SET_DYNAMIC_ROUTES_LIST(state, dynamicRoutesList) {
    state.dynamicRoutesList = dynamicRoutesList;
  },

  SET_USER_LOGOUT(state){
    state.token = ''
    state.userInfo ={}
    localStorage.remove(setuserInfo.SET_USER_TOKEN)
    localStorage.remove(setuserInfo.USER_INFO)
  },

  SET_PERMISSION_BUTTONS(state, permissionButtons){
    state.permissionButtons = permissionButtons
  }
};

const actions = {
 async GET_PERMISSION_ROUTES_LIST({commit ,state , dispatch}) {
      try {
        const res =  await apiQueryUserPermission({id:state.userInfo?.id})
        if (res.success) {
          commit('SET_PERMISSION_ROUTES_LIST',res.data.permissionChildren)  
          dispatch('GET_DYNAMIC_ROUTES_LIST')
          return res
        }else {
          return Promise.reject(false);
        }
      } catch (error) {
        return Promise.reject(error);
      }
  },

  
  GET_DYNAMIC_ROUTES_LIST({ state,commit }) {
    const newPermissionRoutesList = cloneDeep(state.permissionRoutesList)
    const newDynamicRoutes = cloneDeep(DynamicRoutes)
     const seletedRoutesList =  getSeletedRoutes(newPermissionRoutesList)
     const filteredObject =  filterDynamicRoutes(seletedRoutesList,newDynamicRoutes)
     newDynamicRoutes[0].children = filteredObject.filterRoutesList
     commit('SET_DYNAMIC_ROUTES_LIST',filteredObject.filterRoutesList)
     commit('SET_PERMISSION_BUTTONS',filteredObject.stringButtnsArr)
     console.log('filteredObject.stringButtnsArr',filteredObject.stringButtnsArr);
     router.addRoutes(newDynamicRoutes)
},
};

const getters = {};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
});
